/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type BatchProcessItemOperation = typeof BatchProcessItemOperation[keyof typeof BatchProcessItemOperation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchProcessItemOperation = {
  Approve: 'Approve',
  Preview: 'Preview',
  Simulate: 'Simulate',
  Sync: 'Sync',
} as const;
